import {BottomNavigation} from "@progress/kendo-react-layout";
import withRouter from "./withRouter";
import {useEffect, useState} from "react";
import Header from "../components/header/Header";
import useClientStore from "../stores/ClientStore";
import useProjectStore from "../stores/ProjectStore";
import useOwnRightsStore from "../stores/OwnRightsStore";
import Clients from "../components/clients/Clients";




const NavigationContainer = (props) => {

    const {selectedClient, setSelectedClient} = useClientStore((state) => ({selectedClient: state.selectedClient, setSelectedClient: state.selectClient}))
    const {selectedProject, setSelectedProject} = useProjectStore((state) => ({selectedProject: state.selectedItem, setSelectedProject: state.selectItem}))

    const loadRights = useOwnRightsStore(state => state.loadAll)

    useEffect(() => {
        loadRights()
    },[])

    const items = [
        {
            text: 'Client',
            icon: 'tell-a-friend',
            selected: true,
            route: '/',
            show: true
        },
        {
            text: 'Projekt',
            icon: 'folder-open',
            route: '/projects',
            show: true,
            disabled: (selectedClient === null)
        },
        {
            text: 'Výkazy',
            icon: 'clock',
            route: '/tms',
            show: true,
            disabled: (selectedClient === null || selectedProject === null)
        },
        {
            text: 'Naklady',
            icon: 'dollar',
            route: '/expenses',
            show: true,
            disabled: (selectedClient === null || selectedProject === null)
        },

    ].filter(item => item.show !== false);

    const [section, setSection] = useState("")
    const onSelect = e => {
        // setSection(e.itemTarget.props.text)
        props.navigate(e.itemTarget.route);
    };

    const navigateToRoute = route => {
        props.navigate(route);
    }

    const setSelectedItem = pathName => {
        let currentPath = items.find(item => item.route === pathName);
        if (currentPath.text) {
            return currentPath.text;
        }
    };

    let selected = setSelectedItem(props.location.pathname);

    const content = (selectedClient == null) ? <Clients /> : props.children

    console.log("selected", selected)

    return (
        <div className={"page-wrapper"}>
            <div className={"page"}>

                <Header caption={"HSBN Billing"} navigateToRoute={navigateToRoute}/>


                <BottomNavigation
                    positionMode={"fixed"}
                    themeColor={"primary"}
                    fillMode={"flat"}
                    items={items.map((item) => ({
                        ...item,
                        selected: item.text === selected,
                    }))}
                    onSelect={onSelect}
                />

                <div className={"content"}>{props.children}</div>

            </div>

        </div>
    );
};
export default withRouter(NavigationContainer);